// TODO MK: This module is temporary. It can be removed when all pre-polygon drawing shapefiles have been migrated.

/* Actions performed by this module:
  - Create AngelGeojson from existing shapefile .zip
  - Remove obsolete legacy geojson
  - Move legacy shapefile .zip to tract files
*/

import { shapefileClient, getShapeFileAsArrayBuffer } from '@/utils/map/Shapefiles'
import { angelGeojsonClient, AngelGeojson } from '@/utils/map/Geojson'
import { getGeojsonFromShapefile, PREFERRED_SHAPEFILE_TYPE } from './Shapefiles'
import { tractFilesClient } from '@/utils/TractFiles'

const INVALID_USER_ID = -1

export async function migrateLegacyShapefile (tract) {
  if (!tract.tractId) return
  const angelGeojson = await angelGeojsonClient.readGeojson(tract.tractId)
  const attemptMigration = !angelGeojson

  if (attemptMigration) {
    await createAngelGeojsonFromShapefile(tract.tractId)
    await moveShapefileToTractFiles(tract)
  }
}

async function createAngelGeojsonFromShapefile (tractId) {
  const shapefileUrl = await shapefileClient.getShapefileUrl(tractId)
  if (shapefileUrl != null) {
    const shapefile = await fetch(shapefileUrl)
    const blob = await shapefile.blob()
    const angelGeojson = new AngelGeojson(await getGeojsonFromShapefile(blob))
    await angelGeojsonClient.uploadGeojson(tractId, angelGeojson)
  }
}

async function moveShapefileToTractFiles (tract) {
  const shapefileUrl = await shapefileClient.getShapefileUrl(tract.tractId)
  if (shapefileUrl != null) {
    const shapefileBlob = await shapefileClient.getShapefileBlob(tract.tractId)
    const filePathDelimitedByFwdSlash = shapefileBlob.value.name.split('/')
    const currentFileName = filePathDelimitedByFwdSlash.pop()
    const shapefile = await fetch(shapefileUrl)
    const blob = await shapefile.blob()
    const asArrayBuffer = await getShapeFileAsArrayBuffer(blob)
    const file = new File([asArrayBuffer], currentFileName, { type: PREFERRED_SHAPEFILE_TYPE })
    await tractFilesClient.uploadMigratedShapefile(tract, INVALID_USER_ID, file)
    await shapefileClient.deleteShapefile(tract.tractId) // This also deletes the legacy GeoJSON
  }
}
